import Layout from '../../Pages/Layout/Layout.jsx';
import React, { lazy } from 'react';
import CategoriesOfEventsPage from '../../Pages/Events/CategoriesOfEvents';
import CreateCategoryOfEventPage from '../../Pages/Events/CreateCategoryOfEvent';
import CreateEventPage from '../../Pages/Events/CreateEvent';
import CreateFormatPage from '../../Pages/Events/CreateFormat';
import EventsPage from '../../Pages/Events/Events';
import { CreateVacancyPage } from '../../Pages/HR/CreateVacancy';
import { VacanciesPage } from '../../Pages/HR/Vacancies';
import { VacancySummariesPage } from '../../Pages/HR/VacancySummaries';
import { ViewSummaryPage } from '../../Pages/HR/ViewSummary';
import MainPage from '../../Pages/Main/Main';
import CreateNewsPage from '../../Pages/News/CreateNews';
import NewsPage from '../../Pages/News/News';

import CategoryOfPortfolioPage from '../../Pages/Portfolio/CategoryOfPortfolio';
import CreateCategoryOfPortfolioPage from '../../Pages/Portfolio/CreateCategoryOfPortfolio';
import PortfolioPage from '../../Pages/Portfolio/Portfolio';
import CategoriesOfProductPage from '../../Pages/Products/CategoriesOfProduct';
import CreateProductPage from '../../Pages/Products/CreateProduct';
import ProductsPage from '../../Pages/Products/Products';
import ReviewsPage from '../../Pages/Reviews/Reviews';
import CreateRolePage from '../../Pages/Roles/CreateRole';
import RolesPage from '../../Pages/Roles/Roles';
import CreateTeamMemberPage from '../../Pages/Team/CreateTeamMember';
import { TeamGroupCreate } from '../../Pages/Team/TeamGroupCreate';
import CreateUserPage from '../../Pages/Users/CreateUser';
import UsersPage from '../../Pages/Users/Users';
import ResponsesOfVacancyPage from '../../Pages/HR/Responses.jsx';
import SettingsOfLanguagePage from '../../Pages/Languages/SettingsOfLanguage.jsx';
import OrdersPage from '../../Pages/Orders/Orders.jsx';
import NotFoundPage from '../../Pages/404/404.jsx';
import TeamStructuresPage from '../../Pages/Team/TeamStructures.jsx';
import TeamStructurePage from '../../Pages/Team/TeamStructure.jsx';
import TeamGroupPage from '../../Pages/Team/TeamGroup.jsx';
import CreateTeamStructurePage from '../../Pages/Team/CreateStructure.jsx';
import EditTeamStructurePage from '../../Pages/Team/EditTeamStructure.jsx';
import EditTeamGroupPage from '../../Pages/Team/EditTeamGroup.jsx';
import EditTeamMemberPage from '../../Pages/Team/EditTeamMember.jsx';
import LanguageContentPage from '../../Pages/Languages/LanguageContent.jsx';
import CreateIndustryPage from '../../Pages/Portfolio/CreateIndustry.jsx';
import IndustriesPage from '../../Pages/Portfolio/Industries.jsx';
import CreatePortfolioPage from '../../Pages/Portfolio/CreatePortfolio.jsx';
import PromocodesPage from '../../Pages/Promocodes/Promocodes.jsx';
import CreatePromocodePage from '../../Pages/Promocodes/CreatePromocode.jsx';
import CountriesPage from '../../Pages/Countries/Countries.jsx';
import CreateCountryPage from '../../Pages/Countries/CreatyCountry.jsx';
import CountriesGroupsPage from '../../Pages/CountriesGroups/CountriesGroups.jsx';
import CreateCountriesGroupPage from '../../Pages/CountriesGroups/CreateCountriesGroup.jsx';
import EditCountriesGroupPage from '../../Pages/CountriesGroups/EditCountriesGroup.jsx';
import { EditPortfolioPage } from '../../Pages/Portfolio/EditPortfolio.jsx';
import AuthorizationPage from '../../Pages/Authorization/Authorization.jsx';
import FormatsPage from '../../Pages/Events/Formats.jsx';
import EditNewsPage from '../../Pages/News/EditNews.jsx';
import EditEventPage from '../../Pages/Events/EditEvent.jsx';
import EditEventCategoryPage from '../../Pages/Events/EditEventCategory.jsx';
import EditFormatPage from '../../Pages/Events/EditEventFormat.jsx';
import EditProductPage from '../../Pages/Products/EditProduct.jsx';
import CreateCategoryOfProductsPage from '../../Pages/Products/CreateCategoryOfProduct.jsx';
import EditProductCategoryPage from '../../Pages/Products/EditCategory.jsx';
import EditPromocodePage from '../../Pages/Promocodes/EditPromocode.jsx';
import EditCategoryOfPortfolioPage from '../../Pages/Portfolio/EditCategory.jsx';
import EditIndustryPage from '../../Pages/Portfolio/EditIndustry.jsx';
import EditVacancyPage from '../../Pages/HR/EditVacancy.jsx';
import CategoriesOfVacancyPage from '../../Pages/HR/Categories.jsx';
import CreateCategoryOfVacancyPage from '../../Pages/HR/CreateCategory.jsx';
import EditVacancyCategoryPage from '../../Pages/HR/EditCategory.jsx';
import { Navigate, redirect } from 'react-router-dom';
import AccessDeniedPage from '../../Pages/403/403.jsx';

// Реферальная программа
import ReferralMembers from '../../Pages/ReferralProgram/ReferralMembers.jsx';
import ReferralMemberDetail from '../../Pages/ReferralProgram/ReferralMemberDetail.jsx';
import WithdrawalRequests from '../../Pages/ReferralProgram/WithdrawalRequests.jsx';

// Документы
import Documents from '../../Pages/Documents/Documents.jsx';
import CreateDocument from '../../Pages/Documents/CreateDocument.jsx';
import EditDocument from '../../Pages/Documents/EditDocument.jsx';

// Статические текста
const StaticBooks = lazy(() => import('../../Pages/StaticBook/StaticBooks.jsx'));

// Аутстафф
const OutstuffPage = lazy(() => import('../../Pages/Outstuff/Outstuff.jsx'));
const CreateOutstaffPage = lazy(() => import('../../Pages/Outstuff/CreateOutstaff.jsx'));
const EditOutstaffItemPage = lazy(() => import('../../Pages/Outstuff/EditOutstaffItem.jsx'));
const OutstaffColumnsPage = lazy(() => import('../../Pages/Outstuff/OutstaffColumns.jsx'));
const CreateOutstaffGradePage = lazy(() => import('../../Pages/Outstuff/CreateOutstaffGrade.jsx'));
const EditOutstaffGradePage = lazy(() => import('../../Pages/Outstuff/EditOutstaffGrade.jsx'));

// Продукты
const CreateModifierPage = lazy(() => import('../../Pages/ProductModifiers/CreateModifier.jsx'));
const ProductModifiersPage = lazy(
  () => import('../../Pages/ProductModifiers/ProductModifiers.jsx'),
);
const EditModifierPage = lazy(() => import('../../Pages/ProductModifiers/EditModifier.jsx'));

// Страны
const EditCountry = lazy(() => import('../../Pages/Countries/EditCountry.jsx'));

// Портфолио

const EditUserPage = lazy(() => import('../../Pages/Users/EditUser.jsx'));

// Прочее - СМИ о нас
const EditPostPage = lazy(() => import('../../Pages/Posts/EditPost.jsx'));
const PostsPage = lazy(() => import('../../Pages/Posts/Posts.jsx'));
const CreatePostPage = lazy(() => import('../../Pages/Posts/CreatePost.jsx'));
const CategoriesOfPostsPage = lazy(() => import('../../Pages/Posts/Categories.jsx'));
const CreateCategoryOfPostsPage = lazy(() => import('../../Pages/Posts/CreateCategory.jsx'));
const EditCategoryOfPostsPage = lazy(() => import('../../Pages/Posts/EditCategory.jsx'));
const IndustriesOfPostsPage = lazy(() => import('../../Pages/Posts/Industries.jsx'));
const CreateIndustryOfPostsPage = lazy(() => import('../../Pages/Posts/CreateIndustry.jsx'));
const EditIndustryOfPostsPage = lazy(() => import('../../Pages/Posts/EditIndustry.jsx'));

// Комплаенс документы
const ComplianceDocumentsPage = lazy(
  () => import('../../Pages/ComplianceDocuments/ComplianceDocuments.jsx'),
);
const CreateComplianceDocumentPage = lazy(
  () => import('../../Pages/ComplianceDocuments/CreateComplianceDocument.jsx'),
);
const EditComplianceDocumentPage = lazy(
  () => import('../../Pages/ComplianceDocuments/EditComplianceDocument.jsx'),
);

// Партнёры
const PartnersPage = lazy(() => import('../../Pages/Partners/Partners.jsx'));
const CreatePartnersPage = lazy(() => import('../../Pages/Partners/CreatePartner.jsx'));
const EditPartnersPage = lazy(() => import('../../Pages/Partners/EditPartners.jsx'));

// Посещения
const VisitsByDayPage = lazy(() => import('../../Pages/Visits/VisitsByDays.jsx'));
const VisitsByDayCountPage = lazy(() => import('../../Pages/Visits/VisitsByDaysCount.jsx'));

// Заявки с форм
const ApplicationsFormPage = lazy(
  () => import('../../Pages/ApplicationsForm/ApplicationsForm.jsx'),
);
const ApplicationFormDetailPage = lazy(
  () => import('../../Pages/ApplicationsForm/ApplicationFormDetail.jsx'),
);

export const routes_config = [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <MainPage />,
      },
      {
        path: 'shop',
        nameItem: 'Магазин',
        showShildren: true,
        children: [
          {
            index: true,
            element: <Navigate to={'/shop/products'} />,
          },
          {
            path: 'orders',
            nameItem: 'Заказы',
            children: [
              {
                element: <OrdersPage />,
                index: true,
              },
            ],
          },
          {
            path: 'products',
            nameItem: 'Товары',
            children: [
              {
                index: true,
                element: <ProductsPage />,
              },
              {
                path: 'create',
                nameItem: 'Создание',
                element: <CreateProductPage />,
              },
              {
                path: ':id',
                nameItem: 'Обновление',
                children: [
                  {
                    index: true,
                    element: <EditProductPage />,
                  },
                  {
                    path: 'modifiers',
                    nameItem: 'Модификаторы',
                    children: [
                      {
                        element: <ProductModifiersPage />,
                        index: true,
                      },
                      {
                        element: <EditModifierPage />,
                        path: ':modifierId',
                        nameItem: 'Редактирование',
                      },
                      {
                        element: <CreateModifierPage />,
                        path: 'create',
                        nameItem: 'Создание',
                      },
                    ],
                  },
                ],
              },
              {
                path: 'categories',
                nameItem: 'Категории',
                children: [
                  {
                    index: true,
                    element: <CategoriesOfProductPage />,
                  },
                  {
                    path: ':id',
                    element: <EditProductCategoryPage />,
                  },
                  {
                    path: 'create',
                    element: <CreateCategoryOfProductsPage />,
                  },
                ],
              },
            ],
          },
          {
            path: 'promocodes',
            nameItem: 'Промокоды',
            children: [
              {
                index: true,
                element: <PromocodesPage />,
              },
              {
                path: ':id',
                nameItem: 'Создание',
                element: <EditPromocodePage />,
              },
              {
                path: 'create',
                nameItem: 'Создание',
                element: <CreatePromocodePage />,
              },
            ],
          },
        ],
      },
      {
        path: 'posts',
        nameItem: 'Новости',

        children: [
          {
            index: true,
            element: <PostsPage />,
          },
          {
            path: 'create',
            nameItem: 'Создание',
            element: <CreatePostPage />,
          },
          {
            path: ':id',
            nameItem: 'Новость',
            element: <EditPostPage />,
          },
          {
            path: 'categories',
            nameItem: 'Категории',
            children: [
              {
                index: true,
                element: <CategoriesOfPostsPage />,
              },
              {
                path: 'create',
                nameItem: 'Создание',
                element: <CreateCategoryOfPostsPage />,
              },
              {
                path: ':id',
                nameItem: 'Обновление',
                element: <EditCategoryOfPostsPage />,
              },
            ],
          },
          {
            path: 'industries',
            nameItem: 'Индустрии',
            children: [
              {
                index: true,
                element: <IndustriesOfPostsPage />,
              },
              {
                path: 'create',
                nameItem: 'Создание',
                element: <CreateIndustryOfPostsPage />,
              },
              {
                path: ':id',
                nameItem: 'Обновление',
                element: <EditIndustryOfPostsPage />,
              },
            ],
          },
        ],
      },
      {
        path: 'stats',
        nameItem: 'Статистика',
        children: [
          {
            index: true,
            element: <Navigate to={'/stats/visits-days'} />,
          },
          {
            path: 'visits-days',
            nameItem: 'Посещения по дням',
            element: <VisitsByDayPage />,
          },
          {
            path: 'visits-days-count',
            nameItem: 'Посещения за период',
            element: <VisitsByDayCountPage />,
          },
        ],
      },
      {
        path: 'others',
        nameItem: 'Прочее',
        children: [
          {
            index: true,
            element: <Navigate to={'/others/news'} />,
          },
          {
            path: 'applications-form',
            nameItem: 'Заявки с форм',
            children: [
              {
                index: true,
                element: <ApplicationsFormPage />,
              },
              {
                path: ':id',
                nameItem: 'Заявка',
                element: <ApplicationFormDetailPage />,
              },
            ],
          },
          {
            path: 'documents',
            nameItem: 'Документы',
            children: [
              {
                index: true,
                element: <ComplianceDocumentsPage />,
              },
              {
                path: 'create',
                nameItem: 'Создание',
                element: <CreateComplianceDocumentPage />,
              },
              {
                path: ':id',
                nameItem: 'Обновление',
                element: <EditComplianceDocumentPage />,
              },
            ],
          },
          {
            path: 'partners',
            nameItem: 'Партнёры',
            children: [
              {
                index: true,
                element: <PartnersPage />,
              },
              {
                path: 'create',
                nameItem: 'Создание',
                element: <CreatePartnersPage />,
              },
              {
                path: ':id',
                nameItem: 'Обновление',
                element: <EditPartnersPage />,
              },
            ],
          },
          {
            path: 'news',
            nameItem: 'СМИ о нас',
            children: [
              {
                index: true,
                element: <NewsPage />,
              },
              {
                path: 'create',
                nameItem: 'Создание',
                element: <CreateNewsPage />,
              },
              {
                path: ':id',
                nameItem: 'Обновление',
                element: <EditNewsPage />,
              },
            ],
          },
        ],
      },
      {
        path: 'reviews',
        nameItem: 'Отзывы',
        element: <ReviewsPage />,
      },
      {
        path: 'users',
        nameItem: 'Пользователи',
        children: [
          {
            index: true,
            element: <UsersPage />,
          },
          {
            path: 'create',
            nameItem: 'Создание',
            element: <CreateUserPage />,
          },
          {
            path: ':id',
            nameItem: 'Обновление',
            element: <EditUserPage />,
          },
        ],
      },
      {
        path: 'events',
        nameItem: 'Мероприятия',
        children: [
          {
            element: <EventsPage />,
            index: true,
          },
          {
            path: ':id',
            nameItem: 'Обновление',
            element: <EditEventPage />,
          },
          {
            path: 'create',
            nameItem: 'Создание',
            element: <CreateEventPage />,
          },
          {
            path: 'categories',
            nameItem: 'Категории',
            children: [
              {
                index: true,
                element: <CategoriesOfEventsPage />,
              },
              {
                path: ':id',
                nameItem: 'Обновление',
                element: <EditEventCategoryPage />,
              },
              {
                path: 'create',
                nameItem: 'Создание',
                element: <CreateCategoryOfEventPage />,
              },
            ],
          },
          {
            path: 'formats',
            nameItem: 'Форматы',
            children: [
              {
                index: true,
                element: <FormatsPage />,
              },
              {
                path: ':id',
                nameItem: 'Обновление',
                element: <EditFormatPage />,
              },
              {
                path: 'create',
                nameItem: 'Создание',
                element: <CreateFormatPage />,
              },
            ],
          },
        ],
      },
      {
        path: 'static-book',
        nameItem: 'Статические текста',
        children: [
          {
            index: true,
            element: <StaticBooks />,
          },
          {
            path: ':id',
            nameItem: 'Настройки',
            element: <SettingsOfLanguagePage />,
          },
          {
            path: ':id/locale',
            nameItem: 'Контент',
            element: <LanguageContentPage />,
          },
        ],
      },
      {
        path: 'HR',
        nameItem: 'HR',
        children: [
          {
            index: true,
            element: <Navigate to={'/HR/vacancies'} />,
          },
          {
            path: 'vacancies',
            nameItem: 'Вакансии',
            children: [
              {
                index: true,
                element: <VacanciesPage />,
              },
              {
                path: 'create',
                nameItem: 'Создание',
                element: <CreateVacancyPage />,
              },
              {
                path: ':id',
                nameItem: 'Обновление',
                element: <EditVacancyPage />,
              },
              {
                path: ':id/summaries',
                nameItem: 'Отклики',
                element: <VacancySummariesPage />,
              },
              {
                path: ':id/summaries/:summaryId',
                nameItem: 'Просмотр заявки',
                element: <ViewSummaryPage />,
              },
            ],
          },
          {
            path: 'categories',
            nameItem: 'Категории',
            children: [
              {
                index: true,
                element: <CategoriesOfVacancyPage />,
              },
              {
                path: 'create',
                nameItem: 'Создание',
                element: <CreateCategoryOfVacancyPage />,
              },
              {
                path: ':id',
                nameItem: 'Обновление',
                element: <EditVacancyCategoryPage />,
              },
            ],
          },
        ],
      },
      {
        path: 'team-structures',
        nameItem: 'Структуры',
        children: [
          {
            index: true,
            element: <TeamStructuresPage />,
          },
          {
            path: 'create',
            nameItem: 'Создание',
            element: <CreateTeamStructurePage />,
          },
          {
            path: ':id/edit',
            nameItem: 'Редактирование',
            element: <EditTeamStructurePage />,
          },
          {
            path: ':id',
            nameItem: 'Структура',
            element: <TeamStructurePage />,
          },
          {
            path: ':structureId/group/create',
            nameItem: 'Создание группы',
            element: <TeamGroupCreate />,
          },
          {
            path: ':structureId/group/:id',
            nameItem: 'Группы',
            children: [
              {
                index: true,
                element: <TeamGroupPage />,
              },
              {
                path: 'edit',
                nameItem: 'Редактирование группы',
                element: <EditTeamGroupPage />,
              },
              {
                path: 'members',
                nameItem: 'Участники',
                children: [
                  {
                    index: true,
                  },
                  {
                    path: 'create',
                    nameItem: 'Добавить участника',
                    element: <CreateTeamMemberPage />,
                  },
                  {
                    path: ':memberId/edit',
                    nameItem: 'Редактирование участника',
                    element: <EditTeamMemberPage />,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: 'roles',
        nameItem: 'Роли',
        children: [
          {
            index: true,
            element: <RolesPage />,
          },
          {
            path: 'create',
            nameItem: 'Создание',
            element: <CreateRolePage />,
          },
        ],
      },
      {
        path: 'outstaff',
        nameItem: 'Аутстаффинг',
        children: [
          {
            index: true,
            element: <OutstuffPage />,
          },
          {
            path: 'create',
            nameItem: 'Создание услуги',
            element: <CreateOutstaffPage />,
          },
          {
            path: 'columns',
            nameItem: 'Периоды',
            element: <OutstaffColumnsPage />,
          },
          {
            path: ':id',
            nameItem: 'Редактирование услуги',
            element: <EditOutstaffItemPage />,
          },
          {
            path: ':id/grade/create',
            nameItem: 'Создание грейда',
            element: <CreateOutstaffGradePage />,
          },
          {
            path: ':id/grade/:gradeId',
            nameItem: 'Редактирование грейда',
            element: <EditOutstaffGradePage />,
          },
        ],
      },
      {
        path: 'portfolio',
        nameItem: 'Портфолио',
        children: [
          {
            index: true,
            element: <PortfolioPage />,
          },
          {
            path: 'create',
            nameItem: 'Создание',
            element: <CreatePortfolioPage />,
          },
          {
            path: ':id',
            nameItem: 'Портфолио',
            element: <EditPortfolioPage />,
          },
          {
            path: 'categories',
            nameItem: 'Категории',
            children: [
              {
                index: true,
                element: <CategoryOfPortfolioPage />,
              },
              {
                path: 'create',
                nameItem: 'Создание',
                element: <CreateCategoryOfPortfolioPage />,
              },
              {
                path: ':id',
                nameItem: 'Обновление',
                element: <EditCategoryOfPortfolioPage />,
              },
            ],
          },
          {
            path: 'industries',
            nameItem: 'Индустрии',
            children: [
              {
                index: true,
                element: <IndustriesPage />,
              },
              {
                path: 'create',
                nameItem: 'Создание',
                element: <CreateIndustryPage />,
              },
              {
                path: ':id',
                nameItem: 'Обновление',
                element: <EditIndustryPage />,
              },
            ],
          },
        ],
      },
      {
        path: 'documents',
        nameItem: 'Документы',
        children: [
          {
            index: true,
            element: <Documents />,
          },
          {
            path: 'create',
            nameItem: 'Создание',
            element: <CreateDocument />,
          },
          {
            path: ':id',
            nameItem: 'Редактирование',
            element: <EditDocument />,
          },
        ],
      },
      {
        path: 'referral-program',
        nameItem: 'Реферальная программа',
        children: [
          {
            path: 'members',
            nameItem: 'Участники',
            children: [
              {
                index: true,
                element: <ReferralMembers />,
              },
              {
                path: ':id',
                nameItem: 'Детали участника',
                element: <ReferralMemberDetail />,
              },
            ],
          },
          {
            path: 'withdrawal-requests',
            nameItem: 'Заявки на выплату',
            element: <WithdrawalRequests />,
          },
        ],
      },
    ],
  },
  {
    element: <AuthorizationPage />,
    path: 'login',
  },
  {
    element: <NotFoundPage />,
    path: '*',
  },
  {
    path: '403',
    element: <AccessDeniedPage />,
  },
];

export const uninitialization_routes = [
  {
    element: <AuthorizationPage />,
    path: 'login',
  },
  {
    element: <NotFoundPage />,
    path: '*',
  },
];
